import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { track } from '@mc/track-event'
import { DropdownItem } from '@mc/design-system'
import { Highlight } from 'react-instantsearch-dom'
import classes from './Article.module.scss'

const trackClick = (slug) => {
  track('Search Result Clicked', {
    type: 'article',
    slug,
  })
}

const Article = ({ hit }) => (
  <DropdownItem>
    <a
      href={`/articles/${hit.slug}`}
      className='d-flex mc-p-4'
      onClick={() => trackClick(hit.slug)}
    >
      <span className={cn(classes.title, 'mc-text-small')}>
        <Highlight attribute='title' hit={hit} />
      </span>
    </a>
  </DropdownItem>
)

Article.propTypes = {
  hit: PropTypes.object,
}

export default Article
